<template>
  <div class="col-md-12 mx-auto">
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow v-if="partenaireId" :confirm="askConfirm"
                    :params="{partenaireId: partenaireId}" :title="$t('Modify')  + ' ' + $t('l') + ' ' +  $t('partenaire')"
                    route-back="PartenaireShow"/>
        <back-arrow v-else :confirm="askConfirm" :title="$t('New')  + ' ' +  $t('partenaire')"
                    route-back="PartenaireIndex"/>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <b-form v-unsave-detector @submit.stop.prevent="onSubmit">
              <div class="row">
                <div class="col-md-8">
                  <div class="row">
                    <div class="col-md-6">
                      <b-form-group
                        :invalid-feedback="form.name.invalidFeedback"
                        :label="$t('partenaire.Name')"
                        :state="form.name.state"
                        class="medium-label mb-4"
                        label-for="name-input">
                        <b-form-input
                          id="name-input"
                          v-model="form.name.value"
                          :state="form.name.state"
                          maxlength="250"
                          required
                          type="text"
                          v-on:change="removeInvalidFeedback('name'); askConfirm=true;">
                        </b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-md-6">
                      <AutocompleteField
                        :input-class="'medium-label mb-4'"
                        :input-id="'categorie-input'"
                        :input-label="$t('partenaire.Categorie')"
                        :items="categories"
                        :required="true"
                        :search-input="form.categorie.value"
                        @elementValueChanged="setSelectedCategorie">
                      </AutocompleteField>
                    </div>
                    <div class="col-md-6">
                      <b-form-group
                        :invalid-feedback="form.mail.invalidFeedback"
                        :label="$t('partenaire.Mail') "
                        :state="form.mail.state"
                        class="medium-label mb-4"
                        label-for="mail-input">
                        <b-form-input
                          id="mail-input"
                          v-model="form.mail.value"
                          :state="form.mail.state"
                          maxlength="250"
                          required
                          type="email"
                          v-on:change="removeInvalidFeedback('mail'); askConfirm=true;">
                        </b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-md-6">
                      <b-form-group
                        :invalid-feedback="form.phoneNumber.invalidFeedback"
                        :label="$t('partenaire.Phone')"
                        :state="form.phoneNumber.state"
                        class="medium-label mb-4"
                        label-for="phoneNumber-input">
                        <b-form-input
                          id="phoneNumber-input"
                          v-model="form.phoneNumber.value"
                          :state="form.phoneNumber.state"
                          maxlength="250"
                          placeholder="0123456789"
                          required
                          tabindex="4"
                          type="text"
                          v-on:change="removeInvalidFeedback('phoneNumber'); askConfirm=true;">
                        </b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-md-12">
                      <b-form-group
                        :invalid-feedback="form.description.invalidFeedback"
                        :label="$t('partenaire.Description')"
                        :state="form.description.state"
                        class="medium-label mb-4"
                        label-for="description-input">
                        <VueEditor id="description-input" v-model="form.description.value"
                                   :editorToolbar="customToolbar"></VueEditor>
                      </b-form-group>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.logo.invalidFeedback"
                    :label="$t('partenaire.logo.preview')"
                    :label-for="'logo-input'"
                    :state="form.logo.state"
                    class="medium-label mb-4">
                    <custom-form-file
                      :id="'logo-input'"
                      v-model="form.logo.value"
                      :browse-text="$t('Select')"
                      :placeholder="form.logo.filename"
                      :state="form.logo.state"
                      :required="false"
                      accept="image/*"
                      @change="removeInvalidFeedback('logo')"
                    />
                  </b-form-group>
                </div>

              </div>

              <div class="d-flex justify-content-end">
                <b-button :disabled="isLoading" type="submit" variant="primary">{{ $t('Validate') }}</b-button>
              </div>
            </b-form>
          </b-card>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import CustomFormFile from "../../components/b122/editFields/CustomFormFile.vue";
import AutocompleteField from "../../components/b122/editFields/AutocompleteField.vue";
import {VueEditor} from "vue2-editor";

export default {
  name: 'PartenaireCreateEdit',
  components: {AutocompleteField, CustomFormFile, BackArrow, VueEditor},

  data() {
    return {
      partenaire: null,
      partenaireId: this.$route.params.partenaireId,
      askConfirm: false,
      isLoading: false,
      categories: [],
      form: {
        name: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        mail: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        phoneNumber: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        categorie: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        description: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        logo: {
          state: null,
          invalidFeedback: null,
          value: null,
          filename: null
        }
      },
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        ['blockquote', 'code-block'],
        [{list: "ordered"}, {list: "bullet"}],
      ]
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    async fetchData() {
      if (this.partenaireId) {
        await this.fetchPartenaire()
      }
      await this.getCategories()
    },

    async fetchPartenaire() {
      await api.get(`/partenaire/${this.partenaireId}`).then(response => {
        this.partenaire = response.data
        this.form.mail.value = this.partenaire.mail
        this.form.name.value = this.partenaire.name
        this.form.categorie.value = this.partenaire.categorie
        this.form.phoneNumber.value = this.partenaire.phoneNumber
        this.form.description.value = this.partenaire.description
        this.form.logo.filename = this.partenaire.logo ? this.partenaire.logo.filename : null
      })
    },

    onSubmit() {
      this.isLoading = true
      let data = new FormData()
      data.append('name', this.form.name.value)
      data.append('categorie', this.form.categorie.value)
      data.append('phoneNumber', this.form.phoneNumber.value)
      data.append('mail', this.form.mail.value)
      data.append('description', this.form.description.value)
      if (this.form.logo && this.form.logo.value) {
        data.append('logo', this.form.logo.value)
      }

      let url = '/partenaire'
      if (this.partenaire && this.partenaire.id) {
        url = '/partenaire/' + this.partenaire.id
      }

      api({
        method: 'POST',
        url: url,
        data: data
      })
        .then(response => {
          this.isLoading = false
          this.$router.push({name: 'PartenaireIndex'}, () => {
            this.$nextTick(() => {
              this.successToast(this.form.title.value)
            })
          })
        })
        .catch((error) => {
          this.isLoading = false
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({name: 'PartenaireIndex'})
          } else if (error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField].state = false
            this.form[invalidField].invalidFeedback = this.$i18n.t(error.response.data.message)
          }
        })
    },

    removeInvalidFeedback(field) {
      this.askConfirm = true
      this.form[field].state = null
      this.form[field].invalidFeedback = null
    },

    setSelectedCategorie(data) {
      this.form.categorie.value = data
    },

    async getCategories() {
      await api.get(`/partenaire/getPartenaireCategories`)
        .then(response => {
          this.categories = response.data
        })
    },

    successToast(title) {
      this.$bvToast.toast(this.$i18n.t('Partenaire') + ' "' + title + '" ' + this.$i18n.t('registered.object'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/partenaire/PartenaireCreateEdit.vue